import { render, staticRenderFns } from "./SuggestForm.vue?vue&type=template&id=1e2b6c83&scoped=true"
import script from "./SuggestForm.vue?vue&type=script&lang=js"
export * from "./SuggestForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2b6c83",
  null
  
)

export default component.exports